import { BuilderConfig } from '../../types/Builder';

import BusinessHubBuildForIndustry from './business-hub-build-for-industry';

export const BusinessHubBuildForIndustryBuilderConfig = {
    name: 'Business Hub Build For Industry',
    inputs: [
        {
            name: 'showLearnMore',
            type: 'boolean',
            defaultValue: true,
        },
    ],
};

const builderConfig: BuilderConfig<{}> = {
    component: BusinessHubBuildForIndustry,
    config: BusinessHubBuildForIndustryBuilderConfig,
};

export default builderConfig;
